import { $Q, $Qll } from '../utils/query-selector';


const initVideo = () => {
    const videos = $Qll('.jc-video-wrapper .jc-video');
    const videosAutoplay = $Qll('.jc-video-wrapper-autoplay .jc-video');
    // const buttonsPlay = $Qll('.jc-video-play');
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    };

    if (!videos) return;
    
    const overlayImages = $Qll(".jc-video-poster");


    if (overlayImages.length) {
        videos.forEach((video, index) => {
            const overlayImage = overlayImages[index];

            // Play video on custom image click
            overlayImage.addEventListener("click", function () {
                video.play();
            });

            // Hide image on video play and show on pause
            video.addEventListener("play", function () {
                overlayImage.style.display = "none";
            });

            video.addEventListener("pause", function () {
                overlayImage.style.display = "block";
            });

            // Handle seeking
            video.addEventListener("seeking", function () {
                overlayImage.style.display = "none";
            });

            video.addEventListener("seeked", function () {
                if (video.paused) {
                    overlayImage.style.display = "block";
                }
            });
        });

    }


    let observer = new IntersectionObserver(handleIntersection, options);

    function handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.target.classList.contains("autoplay")) {
                if (entry.isIntersecting) {
                    const playPromise = entry.target.play();
                    entry.target.closest('.jc-video-wrapper-autoplay').classList.add('active');

                    if (playPromise !== undefined) {
                        playPromise.catch(error => {
                            console.error("Error trying to autoplay video: ", error);
                        });
                    }
                } else {
                    entry.target.closest('.jc-video-wrapper-autoplay').classList.remove('active');
                    entry.target.pause();
                }
            } else {
                if (entry.target.closest('.jc-video-wrapper-autoplay').classList.contains('active')) {
                    entry.target.closest('.jc-video-wrapper-autoplay').classList.remove('active');
                }
                entry.target.pause();
            }
        });
    }

    videosAutoplay.forEach(video => {
        if (video.classList.contains("autoplay")) {
            video.muted = true;
        }
        observer.observe(video);
    });

};

initVideo();